import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EstRolloverService {

  constructor(private http: HttpClient) {}

  getRolloverData(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_id=31543`;
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  saveRollover(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_id=31540`;
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  getLockedQuarters(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_id=31590`;
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
